export var SUPPORTED_MAJOR_VERSION = '1';
//# sourceMappingURL=constants.js.map